// Pop-up: edit an already-approved tip (reason required; recorded in history).
// Part of the Review page (components/Review.jsx). Split out 2026-10-14.
import { fmtDate, fmtTime } from './helpers.js';

export default function EditApprovedModal({ editApprovedBusy, editApprovedFields, editApprovedReason, editApprovedRow, refLists, refresh, saveApprovedEdit, setEditApprovedFields, setEditApprovedReason, setEditApprovedRow }) {
  return (
    <>
      {editApprovedRow && (
        <div className="modal-backdrop" onClick={() => !editApprovedBusy && setEditApprovedRow(null)}>
          <div className="modal-card" onClick={e => e.stopPropagation()} style={{ minWidth: 520, maxWidth: 680 }}>
            <h3 style={{ marginTop: 0 }}>Edit approved row</h3>
            <div className="small" style={{ marginBottom: '0.5rem', color: '#666' }}>
              {fmtDate(editApprovedRow.date)} {fmtTime(editApprovedRow.arrivalTime)} · id <code>{editApprovedRow._id}</code>
            </div>
            <div className="card" style={{ padding: '0.5rem 0.75rem', background: '#fef9c3', marginBottom: '0.75rem', fontSize: '0.9em', color: '#854d0e' }}>
              <strong>⚠ Editing the approved billing record.</strong> Every change is logged with your name + the reason below. Use this only for legitimate disputes / corrections to invoiced data.
            </div>
            {/* All editable fields rendered as <select> dropdowns sourced from
                refLists. No free-text entry — keeps the approved ledger to a
                known canonical set of values per user direction. */}
            {[
              { key: 'licensePlate', label: 'License plate',
                options: (refLists.plates || []).map(p => p.plate) },
              { key: 'customer',     label: 'Customer',
                options: refLists.customers || [] },
              { key: 'tankSize',     label: 'Tank size (m³)',
                options: refLists.tankSizes || [] },
              { key: 'pctFilled',    label: '% filled',
                options: (refLists.fillPercents || [10,25,50,75,100]) },
              { key: 'pctSolids',    label: '% solids',
                options: (refLists.solidsPercents || [0,10,25,50,75,90,100]) },
              { key: 'site',         label: 'Site',
                options: refLists.sites || [] },
              { key: 'contractor',   label: 'Contractor',
                options: refLists.contractors || [] },
              { key: 'truckNumber',  label: 'Truck #',
                options: refLists.trucks || [] },
              { key: 'driver',       label: 'Driver',
                options: refLists.drivers || [] }
            ].map(f => (
              <label key={f.key} className="small" style={{ display: 'block', marginBottom: '0.35rem' }}>
                {f.label}
                <select value={editApprovedFields[f.key] != null ? String(editApprovedFields[f.key]) : ''}
                  onChange={e => setEditApprovedFields({ ...editApprovedFields, [f.key]: e.target.value })}
                  style={{ width: '100%' }}>
                  <option value="">—</option>
                  {f.options.map(o => <option key={String(o)} value={String(o)}>{String(o)}</option>)}
                </select>
              </label>
            ))}
            <label className="small" style={{ display: 'block', marginTop: '0.5rem', marginBottom: '0.35rem', fontWeight: 600, color: '#991b1b' }}>
              Reason (required — written to audit log)
              <input type="text" value={editApprovedReason}
                onChange={e => setEditApprovedReason(e.target.value)}
                placeholder="e.g. dispute resolved with customer — tank size corrected from 18 to 28 per re-weigh"
                style={{ width: '100%', borderColor: '#991b1b' }} />
            </label>
            <div style={{ marginTop: '1rem', display: 'flex', gap: '0.5rem' }}>
              <button className="refresh-btn" onClick={saveApprovedEdit}
                disabled={editApprovedBusy || !editApprovedReason.trim()}
                style={{ background: '#b91c1c' }}>
                {editApprovedBusy ? 'Saving…' : 'Save change → write audit'}
              </button>
              <button className="refresh-btn" onClick={() => setEditApprovedRow(null)} disabled={editApprovedBusy} style={{ background: '#888' }}>Cancel</button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
